module.exports = __webpack_public_path__ + "img/twitter.8d95601c.png";